import BaseService from "src/packages/BaseService";
import axios from "src/packages/MyAxios";

export default class CouponService extends BaseService {
	static get className () {
		return "coupon";
	}

	static async isValid (data) {
		return axios.post(this.className + "/checkCoupon", data).then((response) => {
			return response.data;
		});
	}
};
